/* -------------------------------------------------------------------------- */
/*                              Device Info Utils                             */
/* -------------------------------------------------------------------------- */
// Genera los headers X-Device-Name y X-Device-Os que el backend lee al crear
// una sesión. El frontend solo manda el navegador y la plataforma:
//   <Browser> Reactive
// El backend antepone el CompleteName/UserName

const parseBrowser = (ua: string): string => {
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\//.test(ua)) return 'Opera';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Browser';
};

const parseOs = (ua: string): string => {
  if (/Windows NT 10/.test(ua)) return 'Windows 10';
  if (/Windows NT 11/.test(ua)) return 'Windows 11';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X ([0-9_]+)/.test(ua)) {
    const match = ua.match(/Mac OS X ([0-9_]+)/);
    return match ? `macOS ${match[1].replace(/_/g, '.')}` : 'macOS';
  }
  if (/Android ([0-9.]+)/.test(ua)) {
    const match = ua.match(/Android ([0-9.]+)/);
    return match ? `Android ${match[1]}` : 'Android';
  }
  if (/iPhone|iPad/.test(ua)) {
    const match = ua.match(/OS ([0-9_]+) like Mac OS X/);
    return match ? `iOS ${match[1].replace(/_/g, '.')}` : 'iOS';
  }
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unknown';
};

export const getDeviceName = (): string => `${parseBrowser(navigator.userAgent)} Reactive`;

export const getDeviceOs = (): string => parseOs(navigator.userAgent);
